import React from 'react'
import styled from 'styled-components'

type LayoutTypes = {
    className?: string,
    children: any,
}

function LayoutMobile(props: LayoutTypes) {


    return (
        <StyledLayout className={props.className}>
            <div className='main'>
                {props.children}
            </div>
        </StyledLayout>
    )
}


const StyledLayout = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  zoom: 0.80;

  .main {

    height: 100%;
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .layout-option {
      margin-bottom: 20px;
    }
  }

`
export default LayoutMobile